module.exports = __webpack_public_path__ + "img/capa1.88734c7d.webp";